module.exports = __webpack_public_path__ + "img/bright_act.6790fb29.png";